<template>
  <v-container fluid>
    <!-- form fillup generate -->
    <div>
      <!-- <mastersFinal
        :dialogStatus.sync="formDialogStatus"
        :studentData.sync="studentData"
      ></mastersFinal>
      <bedFirstSemester
        :dialogStatus.sync="formDialogBedFirstSemester"
        :studentData.sync="studentData"
      ></bedFirstSemester>
      <bed-second-semester
        :dialogStatus.sync="formDialogBedSecondSemester"
        :studentData.sync="studentData"
      ></bed-second-semester>
      <honoursPartOne
        :dialogStatus.sync="formDialogHnsPartOne"
        :studentData.sync="studentData"
      ></honoursPartOne>
      <honoursPartTwo
        :dialogStatus.sync="formDialogHnsPartTwo"
        :studentData.sync="studentData"
      ></honoursPartTwo>
      <honoursPartThree
        :dialogStatus.sync="formDialogHnsPartThree"
        :studentData.sync="studentData"
      ></honoursPartThree>
      <degreeFirstYear
        :dialogStatus.sync="formDialogDegreFirstYear"
        :studentData.sync="studentData"
      ></degreeFirstYear>
      <degreeSecondYear
        :dialogStatus.sync="formDialogDegreSecondYear"
        :studentData.sync="studentData"
      ></degreeSecondYear> -->
      <defaultForm
        :dialogStatus.sync="formDialogDefault"
        :studentData.sync="studentData"
      ></defaultForm>
    </div>
    <!-- end form fillup -->

    <div>
      <ExamMasterFee
        :dialogStatus.sync="showexamMaster"
        :dialogData.sync="examMaster"
      ></ExamMasterFee>
    </div>

    <div>
      <v-container fluid>
        <v-card color="white">
          <v-layout row>
            <v-card flat class="my-0">
              <v-card-title class="dark--text headline"
                >Exam List
              </v-card-title>
            </v-card>
            <v-divider class="my-2" vertical></v-divider>
            <!--<v-text-field
                                            v-model="search"
                                            prepend-inner-icon="search"
                                            label="Search"
                                            class="mt-0"
                                            hide-details
                                            solo
                                            flat
                                            single-line
                        ></v-text-field>-->
            <v-spacer />
            <!-- <v-btn color="primary" dark class="mb-2" @click="newItem">New Item</v-btn> -->
            <input
              type="file"
              ref="fileInput"
              style="display: none;"
              @change="onFileChange"
            />
            <v-btn
              color="indigo"
              dark
              style="margin-top: 1%; margin-bottom: -1%"
              @click="triggerProbableUpload"
            >
              <v-icon left dark>add</v-icon>
              <span>Upload bulk probable data</span>
            </v-btn>
            <input
              type="file"
              ref="probInput"
              style="display: none;"
              @change="selectProbable"
            />
            <v-btn
              color="indigo"
              dark
              style="margin-top: 1%; margin-bottom: -1%"
              @click="triggerFileUpload"
            >
              <v-icon left dark>add</v-icon>
              <span>Upload bulk form fillup data</span>
            </v-btn>
          </v-layout>
        </v-card>

        <v-data-table
          :headers="headers"
          :items="getSchema"
          class="elevation-1"
          :total-items="pagination.totalItems"
          :pagination.sync="pagination"
          :loading="loading"
          :rows-per-page-items="pagination.rowsPerPageItems"
        >
          <template v-slot:items="props">
            <td class="text-xs-left">{{ props.item.exam_display_name }}</td>

            <td class="text-xs-left">
              {{
                props.item.start_date
                  ? formatted_date(props.item.start_date)
                  : ""
              }}
            </td>
            <td class="text-xs-left">
              {{
                props.item.end_date ? formatted_date(props.item.end_date) : ""
              }}
            </td>
            <td class="text-xs-left">
              {{
                props.item.total_student && props.item.total_student.length > 0
                  ? props.item.total_student[0].students
                  : ""
              }}
            </td>
            <td class="justify-left  px-0">
              <div class="layout">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-if="props.item.total_student.length > 0"
                      fab
                      dark
                      small
                      color="warning"
                      @click="showStudentCountDetails(props.item)"
                      v-on="on"
                    >
                      <v-icon dark>list</v-icon>
                    </v-btn>
                  </template>
                  <span>Details List</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-if="props.item.exm_master_fee.length > 0"
                      fab
                      dark
                      small
                      color="primary"
                      @click="generateProbable(props.item)"
                      v-on="on"
                    >
                      <v-icon dark>add</v-icon>
                    </v-btn>
                  </template>
                  <span>Generate Probable</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-if="props.item.exm_master_fee.length > 0"
                      fab
                      dark
                      small
                      color="success"
                      v-on="on"
                      @click="showExamFee(props.item)"
                    >
                      <!-- <v-icon dark>attach_money</v-icon> -->
                      <span>&#2547;</span>
                    </v-btn>
                    <v-btn
                      v-else
                      fab
                      dark
                      small
                      color="red"
                      v-on="on"
                      @click="showExamFee(props.item)"
                    >
                      <!-- <v-icon dark>attach_money</v-icon> -->
                      <span>&#2547;</span>
                    </v-btn>
                  </template>
                  <span>Fee Setup</span>
                </v-tooltip>

                <v-dialog
                  v-model="feeUpdateDialog"
                  persistent
                  max-width="600px"
                >
                  <template v-slot:activator="{ on }">
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        fab
                        small
                        dark
                        @click="feeUpdateDialog = true"
                        style="background-color: #E64A19;"
                      >
                        <v-icon>cached</v-icon>
                      </v-btn>
                      <span>Update Fee</span>
                    </v-tooltip>
                  </template>
                  <v-card>
                    <v-card-title
                      style="background-color: #3F51B5; color: white;"
                    >
                      <span class="headline">Update Fee</span>
                      <v-spacer />
                      <v-btn color="red darken-1" fab small @click="clearData()"
                        ><v-icon style="color:white">close</v-icon></v-btn
                      >
                    </v-card-title>
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 sm12>
                            <v-select
                              :items="updetBy"
                              v-model="selectedUpdateBy"
                              item-text="state"
                              item-value="value"
                              label="Select Update By*"
                              required
                            ></v-select>
                          </v-flex>

                          <v-flex xs12 sm12 v-if="selectedUpdateBy == 1">
                            <v-select
                              name="degree_group_code"
                              label="Degree Group"
                              v-model="searchParam.degree_group_code"
                              :items="getAllDegreeGroup"
                              :item-text="
                                (item) =>
                                  item.degree_group_code +
                                  '-' +
                                  item.degree_group_name
                              "
                              item-value="degree_group_code"
                              v-validate="'required'"
                              data-vv-name="degree_group_code"
                              prepend-icon="edit"
                              @change="getSubjectData"
                              clearable
                            ></v-select>
                          </v-flex>

                          <v-flex xs12 sm12 v-if="selectedUpdateBy == 1">
                            <!-- <v-select
                              v-if="searchParam.degree_group_code"
                              name="subject_code"
                              label="Subject"
                              v-model="searchParam.subject_code"
                              :items="subjectOptions"
                              :item-text="
                                (item) =>
                                  item.subject_code + '-' + item.subject_name
                              "
                              item-value="subject_code"
                              v-validate="'required'"
                              data-vv-name="subject_code"
                              required
                              prepend-icon="edit"
                              clearable
                            ></v-select> -->
                            <v-select
                              v-if="searchParam.degree_group_code"
                              v-model="selectedSubjects"
                              :items="subjectOptions"
                              label="Subject"
                              multiple
                              item-text="display_name"
                              item-value="subject_code"
                              prepend-icon="edit"
                              clearable
                            >
                              <!-- 🔥 SELECT ALL -->
                              <template v-slot:prepend-item>
                                <v-list-tile ripple @click="toggleAllSubjects">
                                  <v-list-tile-action>
                                    <v-icon
                                      :color="
                                        selectedSubjects.length ? 'primary' : ''
                                      "
                                    >
                                      {{ icon }}
                                    </v-icon>
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-title
                                      >Select All</v-list-tile-title
                                    >
                                  </v-list-tile-content>
                                </v-list-tile>
                                <v-divider class="mt-2"></v-divider>
                              </template>

                              <!-- 🔥 FOOTER COUNT -->
                              <template v-slot:append-item>
                                <v-divider class="mb-2"></v-divider>

                                <v-list-tile disabled>
                                  <v-list-tile-content v-if="likesAllSubject">
                                    <v-list-tile-title>
                                      All Subjects Selected
                                    </v-list-tile-title>
                                  </v-list-tile-content>

                                  <v-list-tile-content
                                    v-else-if="likesSomeSubject"
                                  >
                                    <v-list-tile-title>
                                      Selected Count
                                    </v-list-tile-title>
                                    <v-list-tile-sub-title>
                                      {{ selectedSubjects.length }}
                                    </v-list-tile-sub-title>
                                  </v-list-tile-content>

                                  <v-list-tile-content v-else>
                                    <v-list-tile-title>
                                      Please Select Subject
                                    </v-list-tile-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                              </template>
                            </v-select>
                          </v-flex>

                          <v-flex xs12 sm12 v-if="selectedUpdateBy == 2">
                            <v-card-text>
                              <v-text-field
                                class="custom-multiline-text-field"
                                v-model="formattedNumber"
                                label="Enter Registration Number"
                                @input="formatInput"
                                :error-messages="errorMessage"
                                textarea
                              ></v-text-field>

                              <small style="color: red; font-size: 13px"
                                >Enter Registration Number With
                                <strong>Comma (,)</strong> separated</small
                              >
                            </v-card-text>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        v-if="
                          showBot == 1 &&
                            formattedNumber != '' &&
                            selectedUpdateBy == 2
                        "
                        color="indigo darken-1"
                        style="color: white; margin-left: 42%; margin-top: -6%;"
                        @click="
                          updatefeeByReg()
                        "
                        >submits</v-btn
                      >
                      <v-btn
                        v-if="selectedUpdateBy == 1"
                        color="indigo darken-1"
                        style="color: white; margin-left: 42%; margin-bottom: 3%;"
                        @click="updatefee()"
                        >Update</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </td>
          </template>
          <template>
            <!-- v-slot:expand="props" -->
            <v-card flat>
              <v-card-text>Peek-a-boo!</v-card-text>
            </v-card>
          </template>
          <template v-slot:no-data></template>
        </v-data-table>
      </v-container>
    </div>
    <!-- <pre>{{getSchema}}</pre>  -->
  </v-container>
</template>
<script>
// @ts-nocheck

//generate probable
// import mastersFinal from "@/components/probable/masters/mastersFinal.vue";
// import honoursPartOne from "@/components/probable/honours/honoursPartOne.vue";
// import honoursPartTwo from "@/components/probable/honours/honoursPartTwo.vue";
// import honoursPartThree from "@/components/probable/honours/honoursPartThree.vue";
// Honours degree pass
// import degreeFirstYear from "@/components/probable/degree/degreeFirstYear.vue";
// import degreeSecondYear from "@/components/probable/degree/degreeSecondYear.vue";
//bed one year professional
// import bedFirstSemester from "@/components/probable/bedProf/bedFirstSemister.vue";
// import bedSecondSemester from "@/components/probable/bedProf/bedSecondSemister.vue";

// Default from
// const defaultForm = () => import(/* webpackChunkName: "group-foo" */ '@/components/probable/default/default.vue')
// const ExamMasterFee = () => import(/* webpackChunkName: "group-foo" */ '@/components/probable/ExamMasterFee.vue')
// import defaultForm from "@/components/probable/default/default.vue";
// end probable
// import ExamMasterFee from "@/components/probable/ExamMasterFee.vue";
import moment from "moment";
import commonGet from "../../mixin/common_getters_mixin";
import { update } from "lodash";

export default {
  mixins: [commonGet],

  components: {
    defaultForm: () =>
      import(
        /* webpackChunkName: "group-foo" */ "@/components/probable/default/default.vue"
      ),
    ExamMasterFee: () =>
      import(
        /* webpackChunkName: "group-foo" */ "@/components/probable/ExamMasterFee.vue"
      ),
    // mastersFinal,
    // honoursPartOne,
    // honoursPartTwo,
    // honoursPartThree,
    // bedFirstSemester,
    // bedSecondSemester,
    // degreeFirstYear,
    // degreeSecondYear,
  },

  data: () => ({
    selectedSubjects: [],
    subjectOptions: [],
    selectedUpdateBy: 0,
    number: "",
    formattedNumber: "",
    errorMessage: "",
    showBot: 1,
    pagination: {
      rowsPerPage: 10,
      rowsPerPageItems: [10],
    },
    totalDataItems: 0,
    loading: true,
    searchParam: {},
    search: "",

    headers: [
      { text: "Exam Code & Name", align: "left", value: "exam_code" },
      { text: "F.F Start Date", align: "left", value: "start_date" },
      { text: "F.F End Date", align: "left", value: "end_date" },
      { text: "Total Students", align: "left", value: "fat" },
      { text: "Actions", align: "left", sortable: false },
    ],
    updetBy: [
      { state: "Subject", value: "1" },
      { state: "Registration", value: "2" },
    ],

    dialog: false,
    studentData: "",
    examMaster: {},
    showexamMaster: false,
    formDialogStatus: false,
    formDialogHnsPartOne: false,
    formDialogHnsPartTwo: false,
    formDialogHnsPartThree: false,
    formDialogHnsPartFour: false,
    formDialogBedFirstSemester: false,
    formDialogBedSecondSemester: false,
    formDialogDegreFirstYear: false,
    formDialogDegreSecondYear: false,
    formDialogDefault: false,
    feeUpdateDialog: false,
  }),

  computed: {
    getSchema() {
      return this.$store.getters.getAllExamMaster;
    },
    getAllDegreeGroup() {
      return this.$store.getters.getAllDegreeGroup;
    },

    getSubject() {
      return this.$store.getters.getAllSubject;
    },

    subjectOptions() {
      return this.$store.getters.getAllSubject || [];
    },

    likesAllSubject() {
      return this.selectedSubjects.length === this.subjectOptions.length;
    },

    likesSomeSubject() {
      return this.selectedSubjects.length > 0 && !this.likesAllSubject;
    },

    icon() {
      if (this.likesAllSubject) return "check_box";
      if (this.likesSomeSubject) return "indeterminate_check_box";
      return "check_box_outline_blank";
    },
  },

  created() {
    this.getDegree();
    this.$store.dispatch("fetchAllExamsnData");
    // if (localStorage.getItem("reloaded")) {
    //   localStorage.removeItem("reloaded");
    // } else {
    //   localStorage.setItem("reloaded", "1");
    //   location.reload();
    // }
  },
  watch: {
    pagination() {
      this.getDataFromApi();
    },
    /*getLoggedInExam(val) {
             //this.searchParam.exam_code = val.code;
             },
             getLoggedInYear(val) {
             //this.searchParam.exam_year = val.year;
             },*/
    getExamInitiateId(val) {
      this.searchParam.exam_id = val;
      //console.log('exams ====' + val)
      if (val) {
        this.getDataFromApi();
      }
    },
  },

  methods: {
    updatefee() {
      console.log("update fee subjects", this.selectedSubjects);
      let self = this;
      let payload = {
        exam_code: self.getLoggedInExam.code,
        exam_year: self.getLoggedInYear.year,
        subjects: self.selectedSubjects,
      };
      self.$store.dispatch("feeUpdate", payload).then((data) => {
        console.log("Fee updated successfully", data);
        self.clearData();
        self.feeUpdateDialog = false;
      });
    },

    updatefeeByReg() {
      console.log("update fee subjects", this.formattedNumber);
      let self = this;
      let payload = {
        exam_code: self.getLoggedInExam.code,
        exam_year: self.getLoggedInYear.year,
        reg_nos: self.formattedNumber,
      };
      self.$store.dispatch("feeUpdate", payload).then((data) => {
        console.log("Fee updated successfully", data);
        self.clearData();
        self.feeUpdateDialog = false;
      });
    },
    toggleAllSubjects() {
      this.$nextTick(() => {
        if (this.likesAllSubject) {
          this.selectedSubjects = [];
        } else {
          this.selectedSubjects = this.subjectOptions.map(
            (item) => item.subject_code,
          );
        }
      });
    },
    getDegree() {
      let degree = localStorage.getItem("loggedInDegree");

      if (degree) {
        degree = JSON.parse(degree);

        this.$store.dispatch("fetchAllDegreeGroupData", {
          params: {
            degree_code: degree.code,
          },
        });
      }
    },
    getSubjectData(degree_group_code) {
      // Dispatch action to fetch subjects
      this.$store
        .dispatch("fetchAllSubjectData", {
          params: { degree_group_code: degree_group_code },
        })
        .then(() => {
          let subjects = this.$store.getters.getAllSubject;
          // let updatedSubjects = [...subjects];
          // updatedSubjects.unshift({
          //   subject_code: "308",
          //   subject_name: "Update All",
          // });
          // this.subjectOptions = updatedSubjects;
          this.subjectOptions = subjects;
          console.log("Subjects with custom top option:", this.subjectOptions);
        });
    },
    formatInput() {
      if (/[A-Za-z]/.test(this.formattedNumber)) {
        this.errorMessage = "Only numbers are accepted";
        this.showBot = 0;
        return;
      } else {
        this.errorMessage = "";
        this.showBot = 1;
      }
      const plainNumber = this.formattedNumber.replace(/,/g, "");
      const formattedValue = plainNumber.replace(/(.{11})(?!$)/g, "$1,");
      this.formattedNumber = formattedValue;
      this.number = plainNumber;
    },
    clearData() {
      this.formattedNumber = "";
      this.selectedUpdateBy = 0;
      this.searchParam.degree_group_code = null;
      this.searchParam.subject_code = null;
      this.feeUpdateDialog = false;
    },
    setLimit() {
      const { sortBy, page, rowsPerPage } = this.pagination;
      this.searchParam.page = page;
      this.searchParam.limit = rowsPerPage;
      this.searchParam.sort = sortBy;
      this.searchParam.exam_id = this.getExamInitiateId;
      this.searchParam.search = this.search;
    },

    getDataFromApi() {
      this.loading = true;
      this.searchParam.exam_id = this.getExamInitiateId;
      this.setLimit();
      this.$store
        .dispatch("fetchAllExamsnData", this.searchParam)
        .then((data) => {
          this.loading = false;
          this.pagination.totalItems = data.meta.total;
        });
    },

    formatted_date(date) {
      return moment(date).format("DD-MM-YYYY");
    },

    generateProbable(item) {
      let self = this;
      self.$store.dispatch("getSlotAcSession", {
        exam_code: self.getSchema[0].exam_code,
        exam_year: self.getSchema[0].exam_year,
      });
      self.$store.dispatch("fetchSessionData");
      self.$store.dispatch("fetchExamYearData");
      self.$store.dispatch("fetchExamWiseColleges", self.searchParam);
      self.$store.dispatch("fetchExamWiseSession", self.searchParam);
      self.$store.dispatch("fetchCourseListInfo", {
        exam_code: self.getSchema[0].exam_code,
      });
      self.$store.dispatch("fetchCandidateType");

      const exam_code = parseInt(item.exam_code);
      self.studentData = item;
      self.formDialogDefault = true;

      // switch (exam_code) {
      //   case 3302:
      //     this.studentData = item;
      //     this.formDialogStatus = true;
      //     break;
      // case 2201:
      //   this.studentData = item;
      //   this.formDialogHnsPartOne = true;
      //   break;
      // case 2202:
      //   this.studentData = item;
      //   this.formDialogHnsPartTwo = true;
      //   break;
      // case 2203:
      //   this.studentData = item;
      //   this.formDialogHnsPartThree = true;
      //   break;
      // case 8111:
      //   this.studentData = item;
      //   this.formDialogBedFirstSemester = true;
      //   break;
      // case 8112:
      //   this.studentData = item;
      //   this.formDialogBedSecondSemester = true;
      //   break;

      // default:
      //   this.studentData = item;
      //   this.formDialogDefault = true;
      //   break;
      // }
    },

    showStudentCountDetails() {
      this.$router.push({ path: "/prob/pbl-slot-wise" });
    },

    showExamFee(item) {
      this.$store.dispatch("fetchExmFeeHeads");
      this.$store.dispatch("fetchPaperType");
      if (!item.exm_master_fee.length) {
        item.exm_master_fee.push({
          fee_title: null,
          fee_type: "Per Exam",
          credit: null,
          amount: 0,
        });
      }
      this.examMaster = item;
      this.showexamMaster = true;

      // console.log(this.examMaster);
      // console.log(this.showexamMaster);
    },
    onFileChange(event) {
      this.selectedFile = event.target.files[0];
      if (this.selectedFile) {
        this.uploadFile();
      }
    },
    selectProbable(event) {
      this.selectedFile = event.target.files[0];
      if (this.selectedFile) {
        const formData = new FormData();
        formData.append("pl_file", this.selectedFile);
        formData.append("exam_code", this.getLoggedInExam.code);
        formData.append("exam_year", this.getLoggedInYear.year);
        this.$store
          .dispatch("importBalkProbableItemData", formData)
          .then((data) => {
            console.log("Data processed", data);
          })
          .catch((error) => {
            console.error("Upload failed:", error);
          });
      }
    },
    triggerFileUpload() {
      this.$refs.fileInput.click();
    },
    triggerProbableUpload() {
      this.$refs.probInput.click();
    },
    uploadFile() {
      if (this.selectedFile) {
        const formData = new FormData();
        formData.append("ff_file", this.selectedFile);
        formData.append("exam_code", this.getLoggedInExam.code);
        formData.append("exam_year", this.getLoggedInYear.year);
        this.$store
          .dispatch("importBalkFFItemData", formData)
          .then((data) => {
            console.log("Tanvir! called", data);
          })
          .catch((error) => {
            console.error("Upload failed:", error);
          });
      } else {
        console.error("No file selected.");
      }
    },
  },
};
</script>

<style scoped></style>
